import React from 'react';
import {  Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { framework } from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import { libs, ui } from 'saffroncodejs';
var PageManager = framework.PageManager;

class Sales extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isloading: true,
            activeTab: 1,
            data: [{ "HvId": 20, "HvNo": 1, "HvDate": "1393/04/08", "PrvId": 8, "PrvNo": 1, "FullBNo": "92/02/700/3906/2200282", "BNcodesodurText": "شعبه ساري کد 700", "PrvCodesodur": "شعبه ساري کد 700", "BnAgentcodeText": "معصومه لشکر بلوکي کد 3906", "BimeGozarText": "محمد جمال کد 1978819", "PayAmount": 5600000, "PayAmountText": "پنج ميليون و ششصد هزار", "Hvsharh": "طي نامه شماره 932/109/136 مورخ 93/04/01 مبلغ 5.600.000 ريال در وجه بيمه گذار قابل پرداخت مي باشد.", "HvKind": "تسويه", "DmgKindText": "آسيب ديدگي", "PardakhtTxt": "استحقاقي", "GirandeName": "محمد جمال کد 1978819", "CodeMelli": "2249575142", "ErrorMessage": null }]
        }
        this.state.data = [];
        this.loadDetail();

    }

    encodeSodurId(encodedId) {
        return encodedId;
    }

    componentWillReceiveProps(props) {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail() {
        //alert("this.currentSodurId : "+this.currentSodurId);
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Cr/api/Sales/JaniHVInfo",

                { codeMelli: UserManager.MelliCode(), id: this.currentSodurId }

            ),
            BimeManager.header())
            .then((result) => {
                console.log("result.data : ", JSON.stringify(result.data));
                this.setState({ data: result.data, isloading: false })//

            })
            .catch((error) => { alert(error) })
    }


    render() {
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>خودرو ثالث</h4>
                    </Col>
                </Row>

                {(!this.state.isloading) ? (
                    <div className="container ListOfList">
                        <ListGroup>
                            <ListGroupItem >
                            {this.state.data.map((dataa) => {
                                    return (
                                        <div>
                                            <Row>
                                                <Col sm="12" className="alignRight"><span className="bold-head">شماره حواله:</span>{dataa.HvNo}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">تاریخ:</span>{dataa.HvDate}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">شماره پرونده:</span>{dataa.PrvNo}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">شماره بیمه نامه:</span>{dataa.FullBNO}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">واحد صدور:</span>{dataa.CodeSodur}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">معرف:</span>{dataa.AgentText}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">بیمه گذار:</span>{dataa.BimeGozarText}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">مبلغ حواله به عدد:</span>{libs.StringFunctions.currancyPrint(dataa.HvPayAmount) + ('ریال')}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">مبلغ حواله به حروف:</span>{dataa.HvPayAmountText}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">نوع پرداخت:</span>{dataa.PardakhtKindText}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">گيرنده وجه:</span>{dataa.GirandeText}</Col>
                                                <Col sm="12" className="alignRight"><span className="bold-head">توضيحات:</span>{dataa.HvSharh}</Col>

                                            </Row>
                                        </div>
                                    )})}

                            </ListGroupItem>
                        </ListGroup>
                    </div>
                ) : (<ui.Preloader />)

                }
            </div>
        )

    }
}

export default Sales;


// WEBPACK FOOTER //
// ./src/components/Khesarat/Sales.js